
const state = {
    events: [],
    'devices_info': [{
        id: '20230118n1',
        name: 'Node1',
        status: true,
        floor: '一层',
        pos: '角落',
        longitude: '0',
        latitude: '0',
        shareMode: true,
        bind: false
    }],
    'devices_stored': [
        {'id': '20230118n1'},
    ],
    'devices_availble': [
        {'id': '20230119n1'}
    ],
    'devices_pool': [
        {'id': '20230118n1'},
        {'id': '20230119n1'}
    ],
    'pointData': [
        {name: 'node1', value: 80},
        {name: 'node2', value: 80}
    ],
    'pointCoor': {
        'node1': [113.8109, 23.26093],
        'node2': [110, 30]
    },
    online_names: [],
    offline_names: [],
    // 所有节点的10秒内振动
    all_v: {},
    v_color: {'L1': ['rgba(50,136,189,0.7)', '#3288bd'],
        'L2': ['rgba(102,194,165,0.7)', '#66c2a5'],
        'L3': ['rgba(171,221,164,0.7)', '#abdda4'],
        'L4': ['rgba(230,245,152,0.7)','#e6f598'],
        'L5': ['rgba(254,224,139,0.7)', '#fee08b'],
        'L6': ['rgba(253,174,97,0.7)', '#fdae61'],
        'L7': ['rgba(244,109,67,0.7)', '#f46d43'],
        'L8': ['rgba(213,62,79,0.7)', '#d53e4f']},
    e_color: {'0': ['rgba(255, 45, 0,0.3)','rgba(255, 45, 0, 0.8)']
        , '7': ['rgba(255, 175, 0, 0.3)','rgba(255, 175, 0, 0.8)'],
        '14': ['rgba(7, 143, 87, 0.3)','rgba(7, 143, 87, 0.8)'],
        '21': ['rgba(24,35,190,0.3)','rgba(50,63,194,0.8)']},
    //µm/s
    unit: 'µm/s',
    chart_unit: 'µm/s',
    //采样频率
    time_interval: 125,
    //一分钟的行数，此处应该为125，但是其实其采样率并非125 所以改为120
    // one_min_num: Number(125/10*60)
    one_min_num: Number(600),
    verify: false,
    m_v_unit: new Array(10).fill(1),//振动单位 0表示加速度、1表示速度
    time_last: 2, //持续的分钟数
    fft_max: 125/2, //频域图最大值
    fft_min: 0, //频域图最小值
    fft: true, //是否是fft曲线否则为频域图
    amp_max: null,
    amp_min: null,
    // 在线状态
    nodes: [], //节点状态，即
    fft_interval: 20,

    // 身份认证
    username: null,
    role: null,
    permission_loaded: false,
    permission: {
        'components': {
            'battery': false,
            'loss': false,
            'regression': false,
            'signal': false,
            'sync': false,
            'update_time': false,
            'version': false,
            'voltage': false,
            'direction_selector': false,
            'left_sidebar_collapsed': false
        },
        'pages': {
            'daydata': false,
            'manage': false,
            'map': false,
            'realtime': false,
            'three': {
                'all': false,
                'list': []
            }
        }
    },
    //节点名称显示方式 name为显示真实名称如esp0001，nick_name为显示自定义名称如seg67Fa，full为显示所有信息包括name nickname mac
    nodes_display: 'nick_name',
    //三维页面配置信息
    three: [],
    // 检波器全局信息
    geo_params: null,
    graduate_thesis: false

}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js